export default __webpack_public_path__ + "static/main3-f8481d9ca0ded27bb89004581358a84f.png";